__turbopack_context__.v({
  "className": "IHCVua_className",
  "variable": "IHCVua_variable",
});
